import { type FC, useEffect, useRef } from 'react';

export const FavouritesSidebarSkeleton: FC = () => {
  const dialog = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    dialog.current?.showModal();
  }, []);

  return (
    <div className="ui-fixed ui-z-[9999] ui-inset-0 ui-h-full ui-w-full ui-bg-black/40">
      <div className="ui-h-full ui-w-[400px] ui-max-w-[90%] ui-absolute ui-right-0 ui-bg-white ui-top-0 ui-px-4 ui-p-4">
        <div className="ui-flex ui-flex-1 ui-flex-col ui-items-center ui-justify-start ui-h-full ui-animate-pulse">
          {/* Top bar */}
          <div className="ui-h-[20px] ui-w-full ui-mb-4 ui-bg-gray-300 ui-rounded-md" />

          {/* Items Skeleton */}
          <div className="ui-flex ui-flex-col ui-gap-y-4 ui-flex-[0.8] ui-overflow-y-auto ui-w-full">
            {Array(2)
              .fill(null)
              .map((_, index) => (
                <div
                  key={index}
                  className="ui-h-[128px] ui-bg-gray-300 ui-rounded-md"
                />
              ))}
          </div>

          {/* Bottom Bar */}
          <div className="ui-flex ui-flex-col ui-items-center ui-justify-center ui-flex-[0.2] ui-w-full">
            <div className="ui-mb-4 ui-w-[75%] ui-h-4 ui-bg-gray-300" />
            <div className="ui-w-full ui-px-5 ui-flex ui-flex-col ui-items-center ui-justify-between">
              <div className="ui-h-10 ui-bg-gray-300 ui-w-full ui-rounded-md" />
              <div className="ui-h-4 ui-bg-gray-300 ui-w-20 ui-rounded-md ui-mt-4" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
